import React from "react";
import { Carousel } from "react-bootstrap";
import ProgressiveImage from "./ProgressiveImage";
import {
  IMAGE_SIZES,
  getPlaceholderStyle,
  useCarouselImages,
} from "../utils/images";

// Photo carousel of a property card. Only the visible photo and the next one
// are downloaded; the rest load as the user browses.
const PropertyImageCarousel = ({
  property,
  onImageClick,
  overlay,
  children,
  ...carouselProps
}) => {
  const { activeIndex, onSelect, shouldRender, markReady } = useCarouselImages(
    property.images.length,
    { preloadPrevious: false },
  );

  return (
    <Carousel activeIndex={activeIndex} onSelect={onSelect} {...carouselProps}>
      {property.images.map((image, index) => (
        <Carousel.Item key={image}>
          <div
            className="property-image-container"
            style={getPlaceholderStyle(image)}
          >
            {shouldRender(index) && (
              <ProgressiveImage
                src={image}
                sizes={IMAGE_SIZES.card}
                alt={`Casa ${property.id}`}
                onClick={onImageClick}
                onLoad={markReady}
                {...(index !== activeIndex && {
                  loading: "eager",
                  fetchPriority: "low",
                })}
              />
            )}
            {overlay}
          </div>
        </Carousel.Item>
      ))}
      {children}
    </Carousel>
  );
};

export default PropertyImageCarousel;
